import { render, staticRenderFns } from "./FairTowers.vue?vue&type=template&id=1d4e5974&scoped=true"
import script from "./FairTowers.vue?vue&type=script&lang=js"
export * from "./FairTowers.vue?vue&type=script&lang=js"
import style0 from "./FairTowers.vue?vue&type=style&index=0&id=1d4e5974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e5974",
  null
  
)

export default component.exports